import { GRANULARITY } from '@/services/charts-service/constants';
import merge from 'lodash/merge';
import store from '@/store/store';

function getGranularities() {
  return merge({}, GRANULARITY);
}

function getDiffDatesInMinutes() {
  return store.getters['filter/getDiffDatesInMinutes'];
}

export function availableGranularities() {
  const granularities = getGranularities();

  Object.values(granularities).forEach(granularity => {
    granularity.disable = granularity.rule < getDiffDatesInMinutes();
  });

  return granularities;
}

export function minViableGranularity() {
  return Object.values(getGranularities()).find(granularity => getDiffDatesInMinutes() <= granularity.rule);
}

export function savedDatePortion(datePortion) {
  const viableGranulaties = Object.values(getGranularities()).filter(granularity => getDiffDatesInMinutes() <= granularity.rule);
  return viableGranulaties.find(granularity => granularity.datePortion === datePortion);
}

export function getUsage(datePortion) {
  return savedDatePortion(datePortion) || minViableGranularity();
}
